



















































import Vue from 'vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import BookingAssistant1 from '@/components/project/BookingAssistant/BookingAssistant1.vue'
import BookingAssistant2 from '@/components/project/BookingAssistant/BookingAssistant2.vue'
import BookingAssistant4 from '@/components/project/BookingAssistant/BookingAssistant4.vue'
import BookingAssistant12 from '@/components/project/BookingAssistant/BookingAssistant12.vue'
import BookingAssistant13 from '@/components/project/BookingAssistant/BookingAssistant13.vue'
import BookingAssistant14 from '@/components/project/BookingAssistant/BookingAssistant14.vue'

interface ComponentData {
  activeTab: number
}

export default Vue.extend({
  name: 'ProjectBookingAssistant',

  components: {
    BookingAssistant1,
    BookingAssistant2,
    BookingAssistant4,
    BookingAssistant12,
    BookingAssistant13,
    BookingAssistant14
  },

  props: {

  },

  data (): ComponentData {
    return {
      activeTab: 0
    }
  },

  watch: {

  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {
    onBackClick (): void {
      this.activeTab = this.activeTab -1
    },

    onForwardClick (): void {
      this.activeTab = this.activeTab + 1
    },

    onToEndClick (): void {
      this.activeTab = 13
    },

  },

  mounted () {

  }
})
